import { render, staticRenderFns } from "./VolumeContainer.vue?vue&type=template&id=666a0420"
import script from "./VolumeContainer.vue?vue&type=script&lang=js"
export * from "./VolumeContainer.vue?vue&type=script&lang=js"
import style0 from "./VolumeContainer.vue?vue&type=style&index=0&id=666a0420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports